// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"86f1e681","971":"0ae14456","977":"f416d9ab"}[chunkId] + ".chunk.js";
};